// extracted by mini-css-extract-plugin
export default {"head":"TableProductHead_head__BTXSx","headColumn":"TableProductHead_headColumn__Ru0DN"};